import { getAppConfigSetting } from 'utils';
import { datadogRum } from '@datadog/browser-rum';
import axios from 'axios';
import { version } from '../../package.json';

const datadogConfig = {
  version,
  ...getAppConfigSetting('datadog'),
};

export const startRum = () => {
  datadogRum.init(datadogConfig);
};

const getRumUser = () => {
  const rumUser = window.localStorage.getItem('rumUser');
  return rumUser ? JSON.parse(rumUser) : {};
};

export const updateRumUser = () => {
  datadogRum.setUser(getRumUser());
};

export const setRumSessionUser = async () => {
  try {
    const { data } = await axios.get(
      'https://login.apexfintechsolutions.com/api/v1/sessions/me',
      {
        withCredentials: true,
      }
    );

    const {
      userId: id,
      login: email,
      _links: {
        user: { name },
      },
    } = data;

    const rumUser = {
      ...(id && { id }),
      ...(email && { email }),
      ...(name && { name }),
      loginType: 'okta',
    };

    setRumUser(rumUser);

  } catch (e) {
    // don't do anything
  } finally {
    updateRumUser();
  }
};

export const setRumUser = (user) => {
  window.localStorage.setItem('rumUser', JSON.stringify(user));
  datadogRum.setUser(user);
};

export const clearRumUser = () => {
  window.localStorage.removeItem('rumUser');
};



// WEBPACK FOOTER //
// ./src/utils/datadog.js